export default __webpack_public_path__ + "static/media/did_you_draw_this.e29ff8c1.jpg";